import { generateUploadButton, generateUploadDropzone } from '@uploadthing/react'
import { genUploader } from 'uploadthing/client'
import type { FileRouter } from 'uploadthing/server'

export function createUploadThing<TRouter extends FileRouter>() {
  const UploadButton = generateUploadButton<TRouter>()
  const UploadDropzone = generateUploadDropzone<TRouter>()
  const { uploadFiles } = genUploader<TRouter>()

  return { UploadButton, UploadDropzone, uploadFiles }
}
